import React from 'react';
import { Control, Controller } from 'react-hook-form';
import type { NumberInputInputProps } from '@chakra-ui/react';
import { Box, Field, InputElement, NumberInput } from '@chakra-ui/react';
import type { ValueChangeDetails as NumberValueChangeDetails } from '@zag-js/number-input';

type InputPropTypes = {
  invalid?: boolean;
  unit?: string;
  control: Control<any>;
  name: string;
  min?: number;
  max: number;
} & NumberInputInputProps;

const AmountInput: React.FC<InputPropTypes> = ({
  invalid,
  name,
  control,
  unit = 'aud',
  min,
  max,
  ...rest
}) => {
  const format = (val: string = '') => {
    return '$ ' + (val.charAt(1) === '0' ? val.substring(1) : Number(val));
  };
  const parse = (val: string) => val.replace(/^\$ 0/, '');
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value, name: fieldName } }) => {
        return (
          <Field.Root invalid={invalid}>
            <Box px="4" py="8" bg="lightPrimary" position="relative">
              <InputElement
                pointerEvents="none"
                placement="start"
                fontSize="1.625rem"
                fontWeight="semibold"
                color="body"
                textTransform="uppercase"
                top={8}
                left={12}
              >
                {unit}
              </InputElement>
              <NumberInput.Root
                inputMode="numeric"
                min={min}
                max={max}
                onValueChange={(d: NumberValueChangeDetails) =>
                  onChange(parse(d.value))
                }
                value={String(value ? format(value) : format(' 0'))}
                clampValueOnBlur={false}
                name={fieldName}
              >
                <NumberInput.Input
                  {...({
                    ...rest,
                    style: {
                      border: 'none',
                      borderRadius: 0,
                      fontSize: '2.625rem',
                      fontWeight: 500,
                      paddingLeft: '120px',
                      position: 'relative',
                      textAlign: 'end',
                      color: 'var(--chakra-colors-body)',
                    },
                  } as any)}
                />
              </NumberInput.Root>
            </Box>
          </Field.Root>
        );
      }}
    />
  );
};

export default AmountInput;
